import { trans } from '@spotahome/soyuz/client';

import HeartLockIcon from '../Icons/HeartLockIcon';

import './LogoText.scss';

const LogoText = () => {
  return (
    <div className="tenant-guarantees-logo">
      <HeartLockIcon />
      <span className="tenant-guarantees-logo__text">
        {trans('tenant_guarantees.hero.spotahome.guarantee')}
      </span>
    </div>
  );
};

export default LogoText;
